module.exports = __webpack_public_path__ + "img/schema_recherche_groupee_lineaire_explication.2e9831d8.jpg";